import Flickity from 'flickity';
import giftCardModal from './gift-card-modal';

function giftCardActions(opts) {
  const config = {
    dom: {
      accordion: 'accGiftTemplate',
      accordion_btn: 'acc-template--btn',
      delivery: '.js-delivery-option',
      delivery_label: '.js-delivery-option-label',
      delivery_estimate: 'giftCardGetItBy',
      digital_options_wrapper: 'digitalOptions',
      digital_options: '.js-digital-option',
      amount: 'giftCardAmount',
      custom_amount: 'customAmount',
      custom_amount_label: '.js-custom-amount-label',
      add_to_cart: 'giftCardAddToCart',
      add_to_cart_text: 'giftCardAddToCartText',
      templates_wrapper: 'giftTemplate',
      templates: '.js-gift-card-template',
      template_carousel: '.js-templates-carousel',
      template_title: 'giftTemplateTitle',
      template_text: 'giftTemplateText',
    },
    cls: {
      active: 'is-active',
      hidden: 'hide',
      closing: 'is-quickview-closing',
      expose: 'is-quickview-exposed',
    },
  };

  const c = __.extend(config, opts);
  const $deliveryOptions = document.querySelectorAll(c.dom.delivery);
  const $deliveryLabels = document.querySelectorAll(c.dom.delivery_label);
  const $digitalOptions = document.querySelectorAll(c.dom.digital_options);
  const $digitalOptionsWrapper = document.getElementById(c.dom.digital_options_wrapper);
  const $amount = document.getElementById(c.dom.amount);
  const $customAmount = document.getElementById(c.dom.custom_amount);
  const $customAmountLabel = document.querySelector(c.dom.custom_amount_label);
  const $addToCart = document.getElementById(c.dom.add_to_cart);
  const $addToCartText = document.getElementById(c.dom.add_to_cart_text);
  const $templatesWrapper = document.getElementById(c.dom.templates_wrapper);
  const $templateTitle = document.getElementById(c.dom.template_title);
  const $templateText = document.getElementById(c.dom.template_text);
  const $templates = document.querySelectorAll(c.dom.templates);
  const $templateCarousel = document.querySelector(c.dom.template_carousel);

  const { openGiftNote, init: initGiftNote } = giftCardModal();
  const { variantsJson } = SDG.Data || [];

  let $carousel = null;
  let view;

  // setup state
  const giftCardOptions = {
    delivery: null,
    digitalOption: null,
    amount: null,
  };
  const giftCardHandler = {
    set(target, key, value) {
      target[key] = value;

      updateAddToCart();
      return true;
    },
  };
  const giftCard = new Proxy(giftCardOptions, giftCardHandler);

  function init() {
    if (!$amount
      || !$deliveryOptions
      || !$digitalOptions
      || !$digitalOptionsWrapper
      || !$addToCart
      || !$addToCartText) {
      return;
    }

    addEvents();
    __.windowResize(responsive);

    // inputs are disabled by default, enable them once dom is loaded
    __.ready(() => {
      [...$deliveryOptions].forEach(($deliveryOption) => {
        $deliveryOption.disabled = false;
      });
    });
  }

  /**
   * @description Adds event listeners
   * @returns {void}
   */
  function addEvents() {
    __.addEvent({
      id: $amount,
      event: 'change',
      fn: (e) => {
        if (e.target.value) {
          const value = $amount.value.toLowerCase();
          giftCard.amount = value;

          if (value === 'custom amount') {
            showEl($customAmount);
            showEl($customAmountLabel);

            const min = Number($customAmount.min);
            const max = Number($customAmount.max);
            const customValue = Number($customAmount.value);

            if (customValue >= min && customValue <= max) {
              if (giftCard.delivery) {
                $addToCart.disabled = false;
                $addToCartText.innerHTML = `Add to Cart - $${customValue}`;

                if (giftCard.delivery === 'digital') {
                  if (giftCard.digitalOption) {
                    $addToCart.disabled = false;
                    $addToCartText.innerHTML = `Add to Cart - $${customValue}`;
                  } else {
                    $addToCart.disabled = true;
                    $addToCartText.innerHTML = `Add to Cart - $${customValue}`;
                  }

                  if (giftCard.delivery === 'physical') {
                    $addToCartText.innerHTML = `Add to Cart - $${customValue}`;
                  }
                }
              }
            }
          } else {
            hideEl($customAmount);
            hideEl($customAmountLabel);

            if (giftCard.delivery) {
              $addToCart.disabled = false;
              $addToCartText.innerHTML = `Add to Cart - ${value}`;

              if (giftCard.delivery === 'digital') {
                if (giftCard.digitalOption) {
                  $addToCart.disabled = false;
                  $addToCartText.innerHTML = `Add to Cart - ${value}`;
                } else {
                  $addToCart.disabled = true;
                  $addToCartText.innerHTML = `Add to Cart - ${value}`;
                }
              }

              if (giftCard.delivery === 'physical') {
                $addToCartText.innerHTML = `Add to Cart - ${value}`;
              }
            }
          }
        }
      },
    });

    __.addEvent({
      id: $customAmount,
      event: 'change',
      fn: (e) => {
        const { value } = e.target;
        const min = Number(e.target.min);
        const max = Number(e.target.max);

        if (value === '') {
          $addToCart.disabled = true;
          giftCard.amount = null;
          $addToCartText.innerHTML = 'Add to Cart';
        } else if (value >= min && value <= max && giftCard.delivery) {
          $addToCart.disabled = false;
          giftCard.amount = value;
          $addToCartText.innerHTML = `Add to Cart - $${value}`;
        } else {
          $addToCart.disabled = true;
          $addToCartText.innerHTML = 'Add to Cart';
        }
      },
    });

    __.addEvent({
      id: $addToCart,
      event: 'click',
      fn: () => {
        openGiftNote();
      },
    });

    [...$deliveryOptions].forEach(($deliveryOption) => {
      __.addEvent({
        id: $deliveryOption,
        event: 'change',
        fn: () => {
          if ($deliveryOption.value) {
            const value = $deliveryOption.value.toLowerCase();

            giftCard.delivery = value;
            toggleDeliveryOptions(value);
            if (value === 'digital' && (giftCard.amount === 'custom amount' || $customAmount.value)) {
              $addToCart.disabled = true;
            }

            if (value !== 'physical') {
              selectDefaultOption();
            }
          }
        },
      });
    });

    [...$digitalOptions].forEach(($digitalOption) => {
      __.addEvent({
        id: $digitalOption,
        event: 'change',
        fn: () => {
          if ($digitalOption.value) {
            const value = $digitalOption.value.toLowerCase();

            giftCard.digitalOption = value;

            showEl($templatesWrapper);

            const min = Number($customAmount.min);
            const max = Number($customAmount.max);
            const customValue = Number($customAmount.value);

            if (customValue >= min && customValue <= max) {
              $addToCart.disabled = false;
            }

            // init accordion
            SDG.accordion({
              cb: {
                open: () => {
                  responsive();
                },
                on_default_open: () => {
                  responsive();
                  if ($templates?.length > 0) {
                    $templates[0].click();
                  }
                },
              },
              dom: {
                id: c.dom.accordion,
              },
              open_option: 0,
            }).init();
          }
        },
      });
    });

    if ($templates?.length > 0) {
      [...$templates].forEach(($template) => {
        __.addEvent({
          id: $template,
          event: 'change',
          fn: (e) => {
            const ele = e?.target || null;
            if (ele) {
              selectTemplate(ele);
            }
          },
        });
      });
    }

    if ($deliveryLabels?.length > 0) {
      [...$deliveryLabels].forEach(($deliveryLabel) => {
        __.addEvent({
          id: $deliveryLabel,
          event: 'keydown',
          fn: (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              $deliveryLabel.click();
            }
          },
        });
      });
    }
  }

  /**
   * @description Responsive
   * @description Handles responsive carousel
   * @returns {void}
   */
  function responsive() {
    const $btn = document.getElementById(c.dom.accordion_btn);

    if (!$btn || !__.hasClass($btn, c.cls.active)) return;
    if (!$templateCarousel || __.hasClass($templateCarousel, c.cls.hidden)) return;
    __.mq({
      view: 'phone_to_desktop',
      callback: () => {
        if (view !== 'phone_to_desktop') {
          view = 'phone_to_desktop';
          if ($carousel && $carousel !== null) $carousel.destroy();

          $carousel = new Flickity($templateCarousel, {
            contain: true,
            freeScroll: true,
            draggable: true,
            pageDots: false,
            prevNextButtons: false,
          });
        }
      },
    });

    __.mq({
      view: 'small_phone',
      callback: () => {
        if (view !== 'small_phone') {
          view = 'small_phone';

          if ($carousel && $carousel !== null) $carousel.destroy();

          $carousel = new Flickity($templateCarousel, {
            contain: true,
            freeScroll: true,
            draggable: true,
            pageDots: false,
            prevNextButtons: true,
            imagesLoaded: true,
          });
        }
      },
    });
  }

  /**
   * @param {String} val input value
   * @description Show/Hide digital options based on delivery option selected
   * @returns {void}
   */
  function toggleDeliveryOptions(val) {
    const $deliveryEstimate = document.getElementById(c.dom.delivery_estimate);

    if (!val) return;

    if (val === 'digital') {
      showEl($digitalOptionsWrapper);
    }

    if (val === 'physical') {
      hideEl($digitalOptionsWrapper);
      hideEl($templatesWrapper);
      resetTemplate();
    }

    if ($deliveryEstimate) {
      __.removeClass($deliveryEstimate, c.cls.hidden);
    }

    const min = Number($customAmount.min);
    const max = Number($customAmount.max);
    const value = Number($customAmount.value);

    if (value >= min && value <= max) {
      $addToCart.disabled = false;
    }
  }

  /**
   * @description Updates the add to cart button
   * @returns {void}
   */
  function updateAddToCart() {
    const { amount, delivery, digitalOption } = giftCard;

    function anyNull(...args) {
      return args.some((arg) => arg === null);
    }

    if (!variantsJson) return;

    if (delivery === 'physical') {
      if (amount && !anyNull(amount, delivery)) {
        const variant = selectVariant(delivery, delivery, amount);

        if (variant) {
          if (amount === 'custom amount') {
            $addToCartText.innerHTML = 'Add to Cart';
            $addToCart.disabled = true;
          } else {
            $addToCartText.innerHTML = `Add to Cart - ${amount}`;
            $addToCart.disabled = false;
          }
          initGiftNote(giftCard, variant, resetFields);
        }
      }
    }

    if (delivery === 'digital') {
      // if any of the values are null, disable add to cart
      if (anyNull(amount, delivery, digitalOption)) {
        $addToCart.disabled = true;
        return;
      }

      if (amount && !anyNull(amount, digitalOption)) {
        const variant = selectVariant(delivery, digitalOption, amount);
        const template = $addToCart.dataset.templateId;

        if (variant) {
          if (amount === 'custom amount') {
            const min = Number($customAmount.min);
            const max = Number($customAmount.max);
            const customValue = Number($customAmount.value);
            if (customValue >= min && customValue <= max) {
              $addToCartText.innerHTML = `Add to Cart - $${customValue}`;
              $addToCart.disabled = false;
            } else {
              $addToCartText.innerHTML = 'Add to Cart';
              $addToCart.disabled = true;
            }
            variant.giftTemplate = template;
            initGiftNote(giftCard, variant, resetFields);
          } else {
            $addToCartText.innerHTML = `Add to Cart - ${amount}`;
            variant.giftTemplate = template;
            initGiftNote(giftCard, variant, resetFields);
            $addToCart.disabled = false;
          }
        }
      } else {
        $addToCartText.innerHTML = 'Add to Cart';
        $addToCart.disabled = true;
      }
    }
  }

  /**
   * @param {String} deliveryType delivery type
   * @param {String} deliveryOption delivery option
   * @param {String} value input value
   * @description Selects the variant based on the delivery type, delivery option and value
   * @returns {Variant} matching variant
   */
  function selectVariant(deliveryType, deliveryOption, value) {
    const key = `${deliveryType} / ${deliveryOption} / ${value}`;
    const matchingVariant = variantsJson.find((variant) => {
      const variantTitle = variant.title.toLowerCase();

      return variantTitle === key.toLowerCase();
    });

    if (matchingVariant) {
      $addToCart.setAttribute('data-variant-id', matchingVariant.id);

      return matchingVariant;
    }

    return null;
  }

  /**
   * Select Template
   * @param {Element} el
   * @description Selects the template
   * @returns {void}
   */
  function selectTemplate(el) {
    const { title, description } = el.dataset;

    if ($templateText && description) {
      $templateText.innerHTML = description;
    }

    if ($templateTitle && title) {
      $templateTitle.innerHTML = title;
    }

    $addToCart.setAttribute('data-template-id', title);
  }

  /**
   * Reset Template
   * @description Resets the gift template
   * @returns {void}
   * */
  function resetTemplate() {
    const $defaultTemplate = $templates[0];

    // reset digital options
    [...$digitalOptions].forEach(($digitalOption) => {
      $digitalOption.checked = false;
    });

    giftCard.digitalOption = null;

    if (!$defaultTemplate) return;

    const { title, description } = $defaultTemplate.dataset;

    if ($templateText && description) {
      $templateText.innerHTML = description;
    }

    if ($templateTitle && title) {
      $templateTitle.innerHTML = title;
    }

    $addToCart.setAttribute('data-template-id', null);
  }

  /**
   * Hide Element
   * @description Hides the element
   * @param {Element} el
   * @returns {void}
   */
  function hideEl(el) {
    if (el) {
      __.addClass(el, c.cls.hidden);
    }
  }

  /**
   * Show Element
   * @description Shows the element
   * @param {Element} el
   * @returns {void}
   */
  function showEl(el) {
    if (el) {
      __.removeClass(el, c.cls.hidden);
    }
  }

  /**
   * Reset Fields
   * @description resets all fields
   * @returns {void}
   */
  function resetFields() {
    // reset delivery options
    if ($deliveryOptions?.length > 0) {
      [...$deliveryOptions].forEach(($deliveryOption) => {
        $deliveryOption.checked = false;
      });
    }

    if ($digitalOptions?.length > 0) {
      // reset digital options
      [...$digitalOptions].forEach(($digitalOption) => {
        $digitalOption.checked = false;
      });
    }

    // reset amount
    $amount.value = '';
    $customAmount.value = '';
    giftCard.amount = null;
    giftCard.digitalOption = null;
    giftCard.delivery = null;

    // reset template
    resetTemplate();

    // reset add to cart
    $addToCartText.innerHTML = 'Add to Cart';
    $addToCart.disabled = true;
  }

  function selectDefaultOption() { 
    if ($digitalOptions?.length === 1) {
      $digitalOptions[0].click();
    }
  }

  return init();
}

export default giftCardActions;
